export enum SettingsRoutes {
  PREFERENCES = 'preferences',
  RADIUS = 'editRange',
  EDIT_NAME = 'editName',
  CHANGE_PASSWORD = 'changePassword',
  FAVORITES = 'favorites',
  PAYMENT_METHODS = 'paymentMethods',
  TRANSACTIONS = 'transactions',
  SUBSCRIPTIONS = 'subscriptions',
  PRIVACY_POLICY = 'privacyPolicy',
  TERMS_CONDITIONS = 'termsConditions',
  FAQ = 'faq',
  CONTACT_BS = 'contactBS',
  SHOW = 'purchaseShow',
  GIFTS = 'giftsList',
  MERCHANT_DOCUMENTS = 'merchantDocuments',

  //Modals
  LOG_OUT = 'LogOut',
  DELETE_ACCNT = 'DeleteAccnt'
}
